module.exports = __webpack_public_path__ + "img/dance-work-icon1.9ede9166.png";